module.exports = __webpack_public_path__ + "static/event-startup-india-yatra-70abca270522fc3cf114204319f29566.jpg";